"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var path = require("path");
exports.initCommand = function (fs, directory) { return __awaiter(void 0, void 0, void 0, function () {
    var gitDir, directoryAlreadyExists, stats, err_1, isInRootOfGitRepo, stats, err_2, dirsToCreate, filesToCreate, _i, dirsToCreate_1, dir, _a, _b, _c, file;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                gitDir = path.join(directory, '.git');
                directoryAlreadyExists = false;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fs.statAsync(directory)];
            case 2:
                stats = _d.sent();
                directoryAlreadyExists = stats.isDirectory();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _d.sent();
                return [2 /*return*/, {
                        success: false,
                        message: "The directory " + directory + " does not exist. " +
                            "ts-git only supports initializing git repos in directories that already exist.",
                    }];
            case 4:
                _d.trys.push([4, 6, , 7]);
                return [4 /*yield*/, fs.statAsync(gitDir)];
            case 5:
                stats = _d.sent();
                isInRootOfGitRepo = stats.isDirectory();
                return [3 /*break*/, 7];
            case 6:
                err_2 = _d.sent();
                isInRootOfGitRepo = false;
                return [3 /*break*/, 7];
            case 7:
                // If we're already in a repo, don't do anything
                if (isInRootOfGitRepo) {
                    return [2 /*return*/, {
                            success: true,
                            message: gitDir + " is already a repo. No action has been taken.",
                        }];
                }
                dirsToCreate = [
                    '.git',
                    '.git/objects',
                    '.git/refs',
                    '.git/refs/heads',
                    '.git/refs/tags',
                ];
                filesToCreate = {
                    '.git/HEAD': 'ref: refs/heads/master\n',
                    '.git/description': "Unnamed repository; edit this file 'description' to name the repository.\n",
                    '.git/config': '[core]\n' +
                        '\trepositoryformatversion = 0\n' +
                        '\tfilemode = true\n' +
                        '\tbare = false\n',
                };
                _i = 0, dirsToCreate_1 = dirsToCreate;
                _d.label = 8;
            case 8:
                if (!(_i < dirsToCreate_1.length)) return [3 /*break*/, 11];
                dir = dirsToCreate_1[_i];
                return [4 /*yield*/, fs.mkdirAsync(path.join(directory, dir))];
            case 9:
                _d.sent();
                _d.label = 10;
            case 10:
                _i++;
                return [3 /*break*/, 8];
            case 11:
                _a = [];
                for (_b in filesToCreate)
                    _a.push(_b);
                _c = 0;
                _d.label = 12;
            case 12:
                if (!(_c < _a.length)) return [3 /*break*/, 15];
                file = _a[_c];
                return [4 /*yield*/, fs.appendFileAsync(path.join(directory, file), filesToCreate[file], 'utf8')];
            case 13:
                _d.sent();
                _d.label = 14;
            case 14:
                _c++;
                return [3 /*break*/, 12];
            case 15: return [2 /*return*/, {
                    success: true,
                    message: "Initialized empty Git repository in " + gitDir,
                }];
        }
    });
}); };
